// extracted by mini-css-extract-plugin
export var growableInput = "_7i-0";
export var tagContainer = "_7i-2";
export var textInput = "_7i-1";